import { Colors as C } from '../../constants/Colors.js';
import { MP_SURF } from './surfaces.js';

/** Botones de paginación en tema oscuro (Mercado / Subastas). */
export function mpPaginationBtnStyle({ active, disabled }) {
  if (disabled) {
    return {
      padding: '7px 14px',
      borderRadius: 7,
      border: `1px solid ${MP_SURF.chipInactiveBorder}`,
      background: 'transparent',
      color: MP_SURF.textDim,
      fontSize: '0.8rem',
      cursor: 'default',
      fontWeight: 600,
    };
  }
  return {
    padding: '7px 14px',
    borderRadius: 7,
    border: `1px solid ${active ? C.gold : MP_SURF.chipInactiveBorder}`,
    background: active ? C.gold : MP_SURF.chipInactiveBg,
    color: active ? '#0a0a0f' : MP_SURF.chipInactiveColor,
    fontSize: '0.8rem',
    cursor: 'pointer',
    fontWeight: active ? 800 : 600,
  };
}

export function mpPaginationPageBtnStyle(active) {
  return {
    width: 34,
    height: 34,
    borderRadius: 7,
    border: `1px solid ${active ? C.gold : MP_SURF.chipInactiveBorder}`,
    background: active ? C.gold : MP_SURF.chipInactiveBg,
    color: active ? '#0a0a0f' : MP_SURF.chipInactiveColor,
    fontSize: '0.82rem',
    cursor: 'pointer',
    fontWeight: active ? 800 : 400,
  };
}
